import StartEventHook from './StartEventHook'
import Logger from '../Log'
import { bidderForCode, topmostWindowFrame } from '../utils'

const Log = Logger.for('BidderPriorityStartHook')

/*
Lets us pass a smrtb_fb=bidder parameter to force test a specific bidder on demand.
Important this be registered before any other hooks which may modify the bidder listing
 */
export default class BiddeRriorityStartHook extends StartEventHook {
  constructor () {
    super('BidderPriorityStartHook')
  }

  async run (remoteConfig) {
    const params = new URLSearchParams(topmostWindowFrame().location.search)
    if (params.has('smrtb_fb') === false) {
      return
    }

    const bidder = params.get('smrtb_fb')

    const be = bidderForCode(bidder, remoteConfig.bidders())
    if (!be) {
      Log.warn('Found force bidder option but bidder ' + bidder + ' not found!')
      return
    }

    Log.info('Found force bidder parameter for ' + bidder)
    be.params.ecpm = 20
  }
}
